import { FormattedMessage as ReactIntlFormattedMessage } from "react-intl";

import type { FormattedMessageProps } from "./types";

/**
 * The FormattedMessage component is used to display localized text content within a React application.
 * It allows for dynamic content translation based on the current locale.
 *
 * @remarks
 * It supports automatic line breaks if translation includes a `{br}` element.
 *
 * @example
 * ```tsx
 * <FormattedMessage
 *   id="message.key"
 *   defaultMessage="Hello, {name}!{br}Welcome to our site."
 *   values={{ name: "John" }}
 *   tagName="h1"
 * />
 * // Renders as:
 * <h1>Hello, John!<br />Welcome to our site.</h1>
 * ```
 */
const FormattedMessage = ({ defaultMessage, id, tagName, values }: FormattedMessageProps): JSX.Element => {
  if (typeof id !== "string" || id === "") {
    return <></>;
  }

  return (
    <ReactIntlFormattedMessage
      defaultMessage={defaultMessage}
      id={id}
      tagName={tagName}
      values={{ br: <br />, ...values }}
    />
  );
};

export { FormattedMessage };
export type { FormattedMessageProps } from "./types";
